/** ContractorOnboardingRoute — skin-aware switcher for /contractor-onboarding. */
import { useUISkin } from "@/data/UISkinContext";
import ContractorOnboarding from "./ContractorOnboarding";
import ContractorOnboardingCockpit from "./ContractorOnboardingCockpit";

export default function ContractorOnboardingRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <ContractorOnboardingCockpit />;
  return <ContractorOnboarding />;
}
